<template>
	<view>
		<!--图标入口-->
		<view class="diy-navbar" :style="{background:itemData.style.background}">
			<view class="item" v-for="(item, index) in itemData.data" :key="index" :style="'border-left:1rpx solid '+item.color+';width:'+item_width+';'" @click="gotoDetail(item)" v-if="index<itemData.style.rowsNum">
				<text class="gray3" :style="{color:item.color}">{{item.text}}</text>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				//单个宽度
				item_width: '25%'
			}
		},
		props: ['itemData'],
		created() {
			this.item_width = 100 / Math.abs(this.itemData.style.rowsNum) + '%';
		},
		methods: {

			/*跳转页面*/
			gotoDetail(e) {
				if(e.type && e.type == "小程序"){
					wx.navigateToMiniProgram({
					  appId: e.inputname,
					  path: e.linkUrl,
					  extarData: {
					    open: 'happy'
					  },
					  envVersion: 'release',
					  success(res) {
					    // 打开成功
						console.log("成功")
					  }
					})
					
				}else{
					this.gotoPage(e.linkUrl);
				}
			}
		}
	}
</script>

<style>
	.diy-navbar {
		margin: 20rpx;
		padding: 20rpx 0;
		border-radius: 6rpx;
		background: #FFFFFF;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.diy-navbar .item {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 120rpx;
		box-sizing: border-box;
	}
	.diy-navbar .item:first-child {
		border: 0 !important;
	}

	.diy-navbar .item image {
		width: 70rpx;
		height: 70rpx;
	}

	.diy-navbar .item text {
		display: block;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		line-height: 66rpx;
		font-size: 26rpx;
		text-align: center;
	}
</style>
